import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, toHandlers as _toHandlers, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/icon/img-empty.svg'


const _hoisted_1 = {
  key: 0,
  class: "content mt-16 mb-4 px-4"
}
const _hoisted_2 = { class: "mt-3 flex gap-4 mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "background-grey-3 flex rounded-md wrap-img"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex gap-4 items-center" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "flex-none" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-8" }
const _hoisted_11 = { class: "col-1" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "invalid-feedback" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "grid grid-cols-1 gap-x-2" }
const _hoisted_16 = { class: "invalid-feedback" }
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-2" }
const _hoisted_19 = { class: "card flex justify-content-center" }
const _hoisted_20 = { class: "invalid-feedback" }
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-2" }
const _hoisted_24 = { class: "p-inputgroup" }
const _hoisted_25 = { class: "invalid-feedback" }
const _hoisted_26 = { class: "input-icon-right nfc-tag" }
const _hoisted_27 = { class: "invalid-feedback" }
const _hoisted_28 = { class: "col-2" }
const _hoisted_29 = { class: "mb-4" }
const _hoisted_30 = { class: "grid grid-cols-1 gap-x-2" }
const _hoisted_31 = { class: "invalid-feedback" }
const _hoisted_32 = { class: "mb-4" }
const _hoisted_33 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-2" }
const _hoisted_34 = { class: "invalid-feedback" }
const _hoisted_35 = { class: "invalid-feedback" }
const _hoisted_36 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-2" }
const _hoisted_37 = { class: "mb-4" }
const _hoisted_38 = { class: "card flex justify-content-center" }
const _hoisted_39 = { class: "invalid-feedback" }
const _hoisted_40 = { class: "mb-4" }
const _hoisted_41 = { class: "card flex justify-content-center" }
const _hoisted_42 = { class: "invalid-feedback" }
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = { class: "invalid-feedback" }
const _hoisted_45 = { class: "grid grid-cols-1 md:grid-cols-2 gap-8" }
const _hoisted_46 = { class: "col-1" }
const _hoisted_47 = { class: "mb-4" }
const _hoisted_48 = { class: "invalid-feedback" }
const _hoisted_49 = { class: "mb-4" }
const _hoisted_50 = { class: "invalid-feedback" }
const _hoisted_51 = { class: "col-2" }
const _hoisted_52 = { class: "mb-4" }
const _hoisted_53 = { class: "invalid-feedback" }
const _hoisted_54 = { class: "mb-4" }
const _hoisted_55 = { class: "invalid-feedback" }
const _hoisted_56 = { class: "flex mt-40px justify-end" }

import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import InputText from 'primevue/inputtext'
import InputSwitch from 'primevue/inputswitch'
import Calendar from 'primevue/calendar'
import { DatePicker } from 'v-calendar'
import * as Yup from 'yup'
import { Field, useForm } from 'vee-validate'
import { computed, getCurrentInstance, onBeforeMount, onMounted, onUnmounted, ref } from 'vue'
import { useStore } from 'vuex'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiImageUseCase from '@/usecase/apiImageUseCase'
import apiUseCase from '@/usecase/apiUseCase'
import rgxExp from '@/utils/helpers/regExp'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import moment from 'moment'
import environment from '@/configs/environtment'
import { useRoute, useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import HjpDefaultModal from '@/views/components/modal/ModalDefault.vue'
import InlineSvg from 'vue-inline-svg'
import { isNull } from 'lodash'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import TakeCamera from '@/views/components/camera/takeCamera.vue'
import SelectAsync from '@/views/components/form/SelectAsync.vue'
import LastEducationOptions from '../../dataOptions/LastEducationOptions'
import GenderOptions from '../../dataOptions/GenderOptions'
import MaritalStatusOptions from '../../dataOptions/MaritalStatusOptions'
import LastEducationDefiner from '../../dataOptions/helpers/LastEducationsHelper'
import GenderDefiner from '../../dataOptions/helpers/GenderHelper'
import MaritalStatusDefiner from '../../dataOptions/helpers/MaritalStatusHelper'

const moduleStore = 'hjpTable'
const employeeEndpoint = 'talent/v1/employees'
const provinceEndpoint = 'talent/v1/provinces'
const cityEndpoint = 'talent/v1/cities'
const postalCodeEndpoint = 'talent/v1/postalCodes'
const extrnalAuthUserEndpoint = 'talent/v1/externalAuth/users'
const maxSizeFile = 1024 * 1024 * 1

export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeForm',
  setup(__props) {

const isLoading = ref(true)
const isUnauthorized = ref(false)
const store = useStore()
const route = useRoute()
const router = useRouter()
const dataForm = ref()
const tempImgProfile = ref<any | null>(null)
const nfc = ref<string>('')
const nfcInputTimer = ref<ReturnType<typeof setTimeout> | null>(null)
const idPrams = ref(null) as any
const app = getCurrentInstance()
let setFieldValueFunc = null as any
const {
  $toast
} = app!.appContext.config.globalProperties
const isShowCameraDialog = ref(false)
const isShowDataExistDialog = ref(false)
const existingDataList = ref(null as any)
const confirmDataExistDialog = ref({
  title: 'Karyawan Sudah Terdaftar!',
  subTitle: '',
  btnSubmitTitle: 'Lihat Data Karyawan',
  isHtml: true,
  image: require('@/assets/img/modal-confirmation/existing-data.svg')
})

const toast = (status: any, header: any = null, message: any) => {
  $toast.add({
    severity: status,
    summary: header,
    detail: message,
    group: 'bc',
    closable: false,
    life: 3000
  })
}

const initialValues = ref({
  Fullname: null as any,
  PersonelNumber: null as any,
  BirthPlace: null as any,
  BirthDate: null as any,
  Gender: null as any,
  JoinDate: null as any,
  PhoneNumber: null as any,
  Email: null as any,
  UsernameSso: null as any,
  MaritalStatus: null as any,
  LastEducation: null as any,
  ProfilePicture: null as any,
  Address: null as any,
  Province: null as any,
  City: null as any,
  PostalCode: null as any,
  IsActive: null as any,
  NfcTag: null as any
})

const showDataExistDialog = (personnelNumber: string) => {
  confirmDataExistDialog.value.subTitle = `Data karyawan dengan Kode <span style="font-weight:700">${personnelNumber}</span> sudah terdaftar di database. Klik <span style="color:#04776D; font-weight:700">Lihat Data Karyawan</span> untuk mengakses data karyawan tersebut.`
  isShowDataExistDialog.value = true
}

const hideDataExistDialog = () => {
  isShowDataExistDialog.value = false
}

const checkPhoneNumber = async (val: any) => {
  if (val.trim().length > 10) {
    console.log('checkNOW', val.length)
    const res = await apiUseCase.get(`${employeeEndpoint}${returnUrlPrams({
      search: val.length > 10 ? val : '',
      filterField: ['phoneNumber']
    })}`)
  } else {
    console.log('DONTCHECK', val.length)
  }
}

const checkPersonelNumber = async (val: any) => {
  if (val.trim().length > 0) {
    store.dispatch('showLoading')
    await apiUseCase.get(`${employeeEndpoint}${returnUrlPrams({
      search: val,
      filterField: ['oldPersonnelNumber']
    })}`).then((response) => {
      const { error, result } = response
      if (!error) {
        const res = result.data
        // console.log('res', res)
        if (res.length > 0) {
          // console.log('xxx')
          if (res[0].id !== idPrams.value?.id) {
            // console.log('yyy')
            existingDataList.value = {
              ...res[0],
              id: res[0].id
            }
            showDataExistDialog(val)
          }
        } else {
          existingDataList.value = null
        }
      }
    })
  }
  store.dispatch('hideLoading')
}

const schema = Yup.object().shape({
  Fullname: Yup.string()
    .required('Nama Lengkap tidak boleh kosong')
    .min(3, 'Nama Lengkap tidak boleh kurang dari 3 karakter')
    .max(100, 'Nama Lengkap tidak boleh melebihi 100 karakter')
    .matches(rgxExp.notPrefixSuffixSpace, 'Nama Lengkap tidak boleh diawali dan diakhiri dengan spasi')
    .matches(rgxExp.nameJustAlphabetAndSpace, 'Nama Lengkap hanya boleh menggunakan huruf dan spasi'),
  PersonelNumber: Yup.string()
    .required('Kode Karyawan wajib diisi')
    .max(20, 'Kode Karyawan tidak boleh melebihi 20 karakter')
    .matches(rgxExp.notSpaceChar, 'Kode Karyawan tidak boleh hanya menggunakan spasi')
    .matches(rgxExp.employeeCode, 'Kode Karyawan hanya boleh menggunakan huruf, angka, dan -'),
  // NfcTag: Yup.string()
  //   .required('Nomor NFC Tag tidak boleh kosong')
  //   .max(20, 'Nomor NFC Tag tidak boleh melebihi 20 karakter')
  //   .matches(rgxExp.nfcTag, 'Nomor NFC Tag tidak valid'),
    // .test('unique-name', 'Kode Karyawan sudah digunakan', async (value) => {
    //   if (!value) return true
    //   try {
    //     const res = await apiUseCase.get(`${employeeEndpoint}${returnUrlPrams({
    //       search: value.length > 5 ? value : '',
    //       filterField: ['personnelNumber']
    //     })}`)
    //     console.log('rescodeee', res.code)
    //     const filterResult = res.result.data.filter((x: any) => x.Name === value)
    //     console.log('filterResult', filterResult)
    //     if (idPrams.value) {
    //       return filterResult.length === 0 || value === initialValues.PersonelNumber
    //     } return filterResult.length === 0
    //   } catch (error) {
    //     return false
    //   }
    // }),
  PhoneNumber: Yup.string()
    .required('Nomor Telepon tidak boleh kosong')
    .min(10, 'Nomor Telepon minimal 10 karakter')
    .max(13, 'Nomor Telepon maksimal 13 karakter')
    .matches(rgxExp.phoneNumber, 'Nomor Telepon tidak valid'),
  Email: Yup.string()
    .notRequired()
    .email('Email tidak valid')
    .max(100, 'Email tidak boleh melebihi 100 karakter')
    .test('unique-phonenumber', 'Email sudah digunakan', async (val: any) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${employeeEndpoint}${returnUrlPrams({
          search: val,
          filterField: ['email']
        })}`)
        const filterResult = res.result.data.filter((x: any) => x.email === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.value.Email
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  // UsernameSso: Yup.object({
  //   label: Yup.string().required()
  // })
  //   .typeError('Username SSO tidak boleh kosong')
  //   .required('Username SSO tidak boleh kosong'),
  BirthDate: Yup.string()
    .required('Tanggal Lahir tidak boleh kosong'),
  BirthPlace: Yup.string()
    .required('Tempat Lahir tidak boleh kosong')
    .matches(rgxExp.notPrefixSuffixSpace, 'Tempat Lahir tidak boleh diawali dan diakhiri dengan spasi')
    .matches(rgxExp.nameJustAlphabetAndSpace, 'Tempat Lahir hanya boleh menggunakan huruf dan spasi')
    .max(50, 'Tempat Lahir maksimal 50 karakter'),
  JoinDate: Yup.string()
    .required('Tanggal Masuk tidak boleh kosong'),
  Address: Yup.string()
    .required('Alamat Domisili tidak boleh kosong')
    .min(5, 'Alamat Domisili minimal 5 karakter')
    .matches(rgxExp.notPrefixSuffixSpace, 'Alamat Domisili tidak boleh diawali dan diakhiri dengan spasi')
    .max(255, 'Alamat Domisili tidak boleh melebihi 255 karakter'),
  Gender: Yup.object()
    .required('Jenis Kelamin tidak boleh kosong'),
  MaritalStatus: Yup.object()
    .required('Status Pernikahan tidak boleh kosong'),
  LastEducation: Yup.object()
    .required('Pendidikan Terakhir tidak boleh kosong'),
  PostalCode: Yup.string()
    .required('Kode Pos tidak boleh kosong')
    .matches(rgxExp.numberOnly, 'Kode Pos hanya boleh menggunakan angka')
    .min(5, 'Kode Pos minimal 5 karakter')
    .max(6, 'Kode Pos maksimal 6 karakter'),
})

const { values, errors, setFieldValue, handleSubmit, resetForm } = useForm({
  initialValues: initialValues.value,
  validationSchema: schema
})

const onInputFile = (file: any, typeUpload: string) => {
  /* eslint-disable */
  if (file) {
    const totalSize: number = Number((file.size / 1024 / 1024).toFixed(1))
    if (totalSize > 1) {
      toast('error', '', 'Ukuran file lebih dari 1MB.')
    } else {
      /* eslint-disable-next-line */
      if (file) {
        if (typeUpload === 'photo-profile') {
          // tempImgProfile.value = file.blob
          setFieldValue('ProfilePicture', { file: file.file, name: file.name, blob: file.blob })
        }
      }
    }
  }
}

const onBack = () => {
  console.log('back')
}

const openDetailImg = (fileUrl: string) => {
  window.open(fileUrl, '_blank')
}

const processUpload: string | null | any = async (file: any) => {
  console.log('file', file)
  const payload = new FormData()
  payload.append('file', file)
  payload.append('SpecialPath', 'avatar')
  console.log('payload', payload)
  const response = await apiImageUseCase.postOrPut('api/v1/assets', null, payload)
  console.log('response', response)
  if (!response.error) {
    return response.result.path
  }
  return null
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  // checkPhoneNumber(val.PhoneNumber)

  let ProfilePictureTemp = null
  if (val.ProfilePicture?.file) {
    try {
      const uploadedProfilePath = await processUpload(val.ProfilePicture.file)
      if (!uploadedProfilePath) {
        store.dispatch('hideLoading')
        toast('error', 'Gagal', 'Gagal mengunggah foto profil')
        return
      }
      ProfilePictureTemp = `${environment.getApiBaseImageUrl()}${uploadedProfilePath}`
    } catch (error) {
      console.log('profileUploadError', error)
      store.dispatch('hideLoading')
      toast('error', 'Gagal', 'Gagal mengunggah foto profil')
      return
    }
  } else {
    ProfilePictureTemp = val.ProfilePicture
  }
  dataForm.value = {
    'fullName': val.Fullname,
    'joinDate': moment(val.JoinDate).format('YYYY-MM-DD'),
    'birthDate': moment(val.BirthDate).format('YYYY-MM-DD'),
    'birthPlace': val.BirthPlace,
    'address': val.Address,
    'phoneNumber': val.PhoneNumber ? `62${val.PhoneNumber}` : val.PhoneNumber,
    'email': val.Email === '' ? null : val.Email,
    'authUserId': val.UsernameSso?.id,
    'oldPersonnelNumber': val.PersonelNumber,
    'imageUrl': ProfilePictureTemp ?? null,
    'maritalStatus': val.MaritalStatus.value,
    'highestEducationLevel': val.LastEducation.value,
    'gender': val.Gender.value,
    // 'province': val.Province.id,
    'cityId': val.City.id,
    'postalCode': val.PostalCode,
    'nfcCardIdentifier': val.NfcTag
  }
  if (idPrams.value) {
    dataForm.value = {
      ...dataForm.value,
      'id': idPrams.value.id
    }
  }
  console.log('dataForm', dataForm.value)

  const response = await apiUseCase.postOrPut(employeeEndpoint, idPrams.value ? idPrams.value.id : null, dataForm.value)
  console.log('response', response)
  if (!response.error) {
    toast('success', '', idPrams.value ? 'Data Karyawan Berhasil Diubah' : 'Data Karyawan Berhasil Ditambahkan')
    if (!idPrams.value) {
      store.dispatch('employee/setEmployeeId', response.result.id)
      store.dispatch('employee/setEmployeeFormStep', 2)
    }
    // console.log('Employee ID', response.result.id)
  } else {
    toast('error', 'Gagal', response.message.includes('Auth User Id') ? 'Username SSO sudah terhubung dengan Data Karyawan Lain' : response.message)
  }
  store.dispatch('hideLoading')
}

const onSubmit = handleSubmit(async (values: any) => {
  console.log('masuk submit', values)
  await checkPersonelNumber(values.PersonelNumber)
  if (!existingDataList.value) {
    processSubmit(values)
  }
})

const lastEducationOptions = ref(LastEducationOptions())
const genderOptions = ref(GenderOptions())
const maritalStatusOptions = ref(MaritalStatusOptions())
const provinceOptions = ref()
const cityOptions = ref()

const toExistingDataDetail = () => {
  store.dispatch('storeRowDataTable', existingDataList.value)
  router.push({
    name: 'master-employee-form',
    params: {
      id: encryptDecriptMethods.encrypt(existingDataList.value)
    }
  })
  isLoading.value = true
  idPrams.value = existingDataList.value
  existingDataList.value = null
  hideDataExistDialog()
  getData()
}

const onChange = (val: any) => {
  console.log('change', val)
}

const onProvinceChange = (value: any, setFieldValue: any) => {
  setFieldValue('Province', value)
  setFieldValue('City', null)
}

const getUsernameSsoData = async (id: string) => {
  const response = await apiUseCase.get(`${extrnalAuthUserEndpoint}/${id}`)
  // console.log('res', response)
  const data = response.result
  // const filteredRes = response.result.filter((data: any) => data.id === id)
  // console.log('filteredRes', filteredRes[0])
  // return filteredRes.length > 0 ? { ...filteredRes[0], label: `${filteredRes[0].username} - ${filteredRes[0].firstName ?? ''} ${filteredRes[0].lastName ?? ''}` } : null
  return data ? { ...data, label: `${data.username} - ${data.firstName ?? ''} ${data.lastName ?? ''}` } : null
}

const getData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${employeeEndpoint}/${idPrams.value.id}`).then(async (response) => {
    const { error, result } = response
    if (!error) {
      let authUserData: any = null
      if (result.authUserId) {
        authUserData = await getUsernameSsoData(result.authUserId)
        // console.log('authUserData', authUserData)
      }
      // console.log('authUserData', authUserData)
      // store.dispatch('employee/setEmployeeData', '')

      const splittedPhone = result.phoneNumber ? result.phoneNumber.slice(3): result.phoneNumber
      initialValues.value = {
        Fullname: result.fullName,
        PhoneNumber: splittedPhone,
        Email: result.email ?? null,
        PersonelNumber: result.oldPersonnelNumber,
        UsernameSso: authUserData ?? null,
        BirthPlace: result.birthPlace,
        BirthDate: result.birthDate,
        Address: result.address,
        PostalCode: result.postalCode,
        City: result.cityId ? { id: result.cityId, label: result.city, value: result.cityId } : null,
        Province: result.provinceId ? { id: result.provinceId, label: result.province, value: result.provinceId } : null,
        ProfilePicture: result.imageUrl,
        JoinDate: result.joinDate,
        LastEducation: LastEducationDefiner(result.highestEducationLevel),
        Gender: GenderDefiner(result.gender),
        MaritalStatus: MaritalStatusDefiner(result.maritalStatus),
        IsActive: false,
        NfcTag: result.nfcCardIdentifier
      }
      resetForm({ values: initialValues.value })
      isLoading.value = false
      tempImgProfile.value = result.imageUrl
      store.dispatch('employee/setEmployeeData', result)
    } else {
      console.log('error', error)
    }
  })
  store.dispatch('hideLoading')
}

const getAllCitiesByProvinceId = async () => {
  if (!cityOptions.value) {
    const response = await apiUseCase.get(cityEndpoint)
    // console.log('response', response)
    if (!response.error) {
      cityOptions.value = response.result.data
    }
  }
}

const getAllProvinces = async () => {
  if (!provinceOptions.value) {
    const response = await apiUseCase.get(provinceEndpoint)
    // console.log('response', response)
    if (!response.error) {
      provinceOptions.value = response.result.data
    }
  }
}

const showCameraDialog = (setFieldValue: any) => {
  console.log('camera true', setFieldValue)
  setFieldValueFunc = setFieldValue
  isShowCameraDialog.value = true
}

const hideCameraDialog = (photo: any = null) => {
  isShowCameraDialog.value = false
  setFieldValueFunc = null
}

const useCurrentPhoto = (photo: any = null) => {
  console.log('photo', photo)
  if (photo) {
    setFieldValueFunc('ProfilePicture', {
      blob: URL.createObjectURL(photo.blob!),
      file: photo.file
    })
    tempImgProfile.value = photo
  }
}

const onManualInputBlur = (setFieldValue: any, field: any, event: FocusEvent) => {
  const input = (event.target as HTMLInputElement).value
  console.log('input', input)
  const parsed = moment(input, 'DD/MM/YYYY', true)
  if (parsed.isValid()) {
    setFieldValue(field, parsed.toDate())
  } else {
    setFieldValue(field, null)
  }
}


const convertToHex = (val: string | number): string => {
  const value = String(val).trim()

  // Pastikan input berupa angka desimal
  if (!/^\d+$/.test(value)) {
    return ''
  }

  const decimal = BigInt(value)

  // UID yang diasumsikan terdiri dari 4 byte
  if (decimal < 0n || decimal > 0xFFFFFFFFn) {
    return ''
  }

  const hex = decimal
    .toString(16)
    .toUpperCase()
    .padStart(8, '0')

  return hex.match(/.{2}/g)!.reverse().join(':')
}



const handleChangeX = (value: string): string => {
  const input = value.trim()

  console.log('val', input)

  if (!input.includes(':')) {
    const temp = convertToHex(input)

    console.log('converted', temp)

    if (temp) {
      initialValues.value.NfcTag = temp
      nfc.value = temp
      setFieldValue('NfcTag', temp)
    }
    return temp
  } else {
    const hex = input.toUpperCase()
    nfc.value = hex
    initialValues.value.NfcTag = hex
    setFieldValue('NfcTag', hex)
    return hex
  }
}

const handleNfcInput = (event: Event) => {
  const target = event.target
  if (!(target instanceof HTMLInputElement)) return

  setFieldValue('NfcTag', target.value)
  if (nfcInputTimer.value) clearTimeout(nfcInputTimer.value)
  nfcInputTimer.value = setTimeout(() => handleChangeX(target.value), 500)
}

const handleNfcEnter = (event: KeyboardEvent) => {
  const target = event.target
  if (!(target instanceof HTMLInputElement)) return

  if (nfcInputTimer.value) clearTimeout(nfcInputTimer.value)
  handleChangeX(target.value)
}

onUnmounted(() => {
  if (nfcInputTimer.value) clearTimeout(nfcInputTimer.value)
})


onMounted(() => {
  if (route.params.id) {
    idPrams.value = encryptDecriptMethods.decrypt(route.params.id)
    getData()
  } else {
    isLoading.value = false
  }
  getAllProvinces()
  getAllCitiesByProvinceId()
})

onBeforeMount(() => {
  store.dispatch('employee/flushEmployeeData')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"])),
            class: "form-container"
          }, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "md:flex justify-between" }, [
              _createElementVNode("div", { class: "col-1" }, [
                _createElementVNode("p", { class: "font-bold text-xl mb-2" }, "Informasi Karyawan")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                (!_unref(values).ProfilePicture && !tempImgProfile.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[18] || (_cache[18] = [
                      _createElementVNode("div", { class: "m-auto" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "mx-auto"
                        }),
                        _createElementVNode("p", { class: "text-grey-5 text-xs font-bold" }, "Max. 1MB")
                      ], -1)
                    ])))
                  : (_unref(values).ProfilePicture?.blob)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: _unref(values).ProfilePicture?.blob,
                        class: "wrap-img cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (openDetailImg(_unref(values).ProfilePicture.blob)))
                      }, null, 8, _hoisted_4))
                    : (tempImgProfile.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: tempImgProfile.value,
                          class: "wrap-img cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (openDetailImg(tempImgProfile.value)))
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "font-bold text-xl mb-2" }, "Foto Profil", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(ButtonFileUpload, {
                      inputId: "idPhotoProfile",
                      size: maxSizeFile,
                      onOnInputFile: _cache[2] || (_cache[2] = (newFile, oldFile) => onInputFile(newFile, 'photo-profile', _unref(setFieldValue)))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            (!_unref(values).ProfilePicture)
                              ? (_openBlock(), _createBlock(_unref(Button), {
                                  key: 0,
                                  class: "btn-back flex gap-x-2"
                                }, {
                                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                                    _createElementVNode("i", { class: "pi pi-upload font-black text-sm" }, null, -1),
                                    _createTextVNode(" Upload")
                                  ])),
                                  _: 1,
                                  __: [19]
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    (!_unref(values).ProfilePicture)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 0,
                          class: "btn-back flex gap-x-2",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showCameraDialog(_unref(setFieldValue))))
                        }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createElementVNode("i", { class: "pi pi-camera font-black text-sm" }, null, -1),
                            _createTextVNode(" Buka Camera ")
                          ])),
                          _: 1,
                          __: [20]
                        }))
                      : _createCommentVNode("", true),
                    (_unref(values).ProfilePicture)
                      ? (_openBlock(), _createBlock(_unref(Button), {
                          key: 1,
                          class: "btn-back gap-x-2 flex",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(setFieldValue)('ProfilePicture', null), tempImgProfile.value = null))
                        }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "pi pi-times color-danger text-sm" }, null, -1),
                            _createElementVNode("p", { class: "color-danger font-extrabold" }, "Hapus", -1)
                          ])),
                          _: 1,
                          __: [21]
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", {
                    for: "fullname",
                    class: "label-text required"
                  }, "Nama Lengkap", -1)),
                  _createVNode(_unref(Field), { name: "Fullname" }, {
                    default: _withCtx(({ handleChange, handleBlur, field }) => [
                      _createVNode(_unref(InputText), _mergeProps({ id: "fullname" }, field, {
                        "aria-describedby": "fullname-help",
                        class: `input-primary ${_unref(errors).Fullname ? 'input-invalid' : ''}`,
                        placeholder: "Masukkan Nama Lengkap",
                        onChange: handleChange,
                        onBlur: handleBlur
                      }), null, 16, ["class", "onChange", "onBlur"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(errors).Fullname), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _cache[24] || (_cache[24] = _createElementVNode("label", {
                        for: "id-number",
                        class: "label-text required"
                      }, "Kode Karyawan Lama", -1)),
                      _createVNode(_unref(Field), { name: "PersonelNumber" }, {
                        default: _withCtx(({ handleChange, handleBlur, field }) => [
                          _createVNode(_unref(InputText), _mergeProps({
                            id: "id-number",
                            "aria-describedby": "id-number-help",
                            placeholder: "1234xxx",
                            class: `input-primary ${_unref(errors).PersonelNumber ? 'input-invalid' : ''}`
                          }, field, {
                            onChange: handleChange,
                            onBlur: handleBlur,
                            maxlength: 16,
                            disabled: false
                          }), null, 16, ["class", "onChange", "onBlur"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(errors).PersonelNumber), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", {
                        for: "gender",
                        class: "label-text required"
                      }, "Jenis Kelamin", -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_unref(Field), {
                          id: "gender",
                          name: "Gender",
                          class: _normalizeClass(`input-primary ${_unref(errors).Gender ? 'input-invalid' : ''}`),
                          validateOnInput: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Dropdown), {
                              modelValue: _unref(values).Gender,
                              "onUpdate:modelValue": [
                                _cache[5] || (_cache[5] = ($event: any) => ((_unref(values).Gender) = $event)),
                                _cache[6] || (_cache[6] = (val) => _unref(setFieldValue)('Gender', val))
                              ],
                              options: genderOptions.value,
                              optionLabel: "label",
                              placeholder: "Pilih Jenis Kelamin",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(errors).Gender), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", {
                        for: "joinDate",
                        class: "label-text required"
                      }, "Tanggal Masuk", -1)),
                      _createVNode(_unref(Field), { name: "JoinDate" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_unref(DatePicker), _mergeProps(field, {
                            modelValue: _unref(values).JoinDate,
                            "onUpdate:modelValue": [
                              _cache[7] || (_cache[7] = ($event: any) => ((_unref(values).JoinDate) = $event)),
                              _cache[8] || (_cache[8] = (val) => _unref(setFieldValue)('JoinDate', val))
                            ],
                            masks: {
                        input: 'DD/MM/YYYY'
                      }
                          }), {
                            default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                              _createVNode(_unref(InputText), _mergeProps({
                                id: "joinDate",
                                "aria-describedby": "joinDate-help",
                                placeholder: "DD/MM/YYYY",
                                value: inputValue
                              }, _toHandlers(inputEvents), {
                                masks: { input: 'DD/MM/YYYY' },
                                class: `input-primary ${_unref(errors).JoinDate ? 'input-invalid' : ''}`,
                                onClick: togglePopover
                              }), null, 16, ["value", "class", "onClick"])
                            ]),
                            _: 2
                          }, 1040, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(errors).JoinDate), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", null, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", {
                        for: "phone",
                        class: "label-text required"
                      }, "Nomor Telepon", -1)),
                      _createVNode(_unref(Field), { name: "PhoneNumber" }, {
                        default: _withCtx(({ handleBlur, field }) => [
                          _createElementVNode("div", _hoisted_24, [
                            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "p-inputgroup-addon" }, _toDisplayString('+62'), -1)),
                            _createVNode(_unref(InputText), _mergeProps({
                              class: `input-primary ${_unref(errors).PhoneNumber ? 'input-invalid' : ''}`,
                              id: "phone"
                            }, field, {
                              "aria-describedby": "phone-help",
                              placeholder: "08xx",
                              type: "tel",
                              onBlur: handleBlur,
                              minlength: 10,
                              maxlength: 14
                            }), null, 16, ["class", "onBlur"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(errors).PhoneNumber), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", {
                        for: "nfc-number",
                        class: "label-text"
                      }, "Nomor NFC Tag", -1)),
                      _createVNode(_unref(Field), { name: "NfcTag" }, {
                        default: _withCtx(({ handleChange, handleBlur, field }) => [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_unref(InputText), _mergeProps({
                              id: "nfc-number",
                              "aria-describedby": "nfc-number-help",
                              placeholder: "123xxx",
                              class: `input-primary ${_unref(errors).NfcTag ? 'input-invalid' : ''}`
                            }, field, {
                              onInput: handleNfcInput,
                              onChange: handleChange,
                              onBlur: handleBlur,
                              readonly: false,
                              onKeyup: _withKeys(handleNfcEnter, ["enter"])
                            }), null, 16, ["class", "onChange", "onBlur"]),
                            _createVNode(_unref(InlineSvg), {
                              src: require('@/assets/img/icon/nfc-outline-black.svg')
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(errors).NfcTag), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", null, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", {
                        for: "usernameSso",
                        class: "label-text"
                      }, "Username SSO", -1)),
                      _createVNode(_unref(Field), { name: "UsernameSso" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(SelectAsync, _mergeProps(field, {
                            inputId: `usernameSso`,
                            endpoint: `${extrnalAuthUserEndpoint}`,
                            fieldLabel: (v) => `${v.username} - ${v.firstName ?? ''} ${ v.lastName ?? ''}`,
                            modelValue: _unref(values).UsernameSso,
                            clearable: true,
                            searchFields: ['username'],
                            placeholder: `Pilih Username`,
                            classname: 'custom-select'
                          }), null, 16, ["endpoint", "fieldLabel", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(errors).UsernameSso), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", null, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", {
                        for: "birthPlace",
                        class: "label-text required"
                      }, "Tempat Lahir", -1)),
                      _createVNode(_unref(Field), { name: "BirthPlace" }, {
                        default: _withCtx(({ handleChange, handleBlur, field }) => [
                          _createVNode(_unref(InputText), _mergeProps({ id: "birthPlace" }, field, {
                            "aria-describedby": "birthPlace-help",
                            class: `input-primary ${_unref(errors).BirthPlace ? 'input-invalid' : ''}`,
                            placeholder: "Masukkan Tempat Lahir",
                            onChange: handleChange,
                            onBlur: handleBlur
                          }), null, 16, ["class", "onChange", "onBlur"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(errors).BirthPlace), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", {
                        for: "birth-date",
                        class: "label-text required"
                      }, "Tanggal Lahir", -1)),
                      _createVNode(_unref(Field), { name: "BirthDate" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DatePicker), {
                            modelValue: _unref(values).BirthDate,
                            "onUpdate:modelValue": [
                              _cache[9] || (_cache[9] = ($event: any) => ((_unref(values).BirthDate) = $event)),
                              _cache[10] || (_cache[10] = (val) => _unref(setFieldValue)('BirthDate', _unref(moment)(val).format('YYYY-MM-DD')))
                            ],
                            masks: {
                        input: 'DD/MM/YYYY'
                      },
                            "max-date": new Date()
                          }, {
                            default: _withCtx(({ togglePopover, inputValue, inputEvents }) => [
                              _createVNode(_unref(InputText), _mergeProps({
                                id: "birth-date",
                                "aria-describedby": "birth-date-help",
                                placeholder: "DD/MM/YYYY",
                                value: inputValue,
                                class: `input-primary ${_unref(errors).BirthDate ? 'input-invalid' : ''}`,
                                masks: { input: 'DD/MM/YYYY' }
                              }, _toHandlers(inputEvents), { onClick: togglePopover }), null, 16, ["value", "class", "onClick"])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "max-date"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(errors).BirthDate), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_37, [
                      _cache[33] || (_cache[33] = _createElementVNode("label", {
                        for: "maritalStatus",
                        class: "label-text required"
                      }, "Status Pernikahan", -1)),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_unref(Field), {
                          id: "maritalStatus",
                          name: "MaritalStatus",
                          class: _normalizeClass(`input-primary ${_unref(errors).MaritalStatus ? 'input-invalid' : ''}`),
                          validateOnInput: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Dropdown), {
                              modelValue: _unref(values).MaritalStatus,
                              "onUpdate:modelValue": [
                                _cache[11] || (_cache[11] = ($event: any) => ((_unref(values).MaritalStatus) = $event)),
                                _cache[12] || (_cache[12] = (val) => _unref(setFieldValue)('MaritalStatus', val))
                              ],
                              options: maritalStatusOptions.value,
                              optionLabel: "label",
                              placeholder: "Pilih Status Pernikahan",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(errors).MaritalStatus), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_40, [
                      _cache[34] || (_cache[34] = _createElementVNode("label", {
                        for: "lastEducation",
                        class: "label-text required"
                      }, "Pendidikan Terakhir", -1)),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_unref(Field), {
                          id: "lastEducation",
                          name: "LastEducation",
                          class: _normalizeClass(`input-primary ${_unref(errors).LastEducation ? 'input-invalid' : ''}`),
                          validateOnInput: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Dropdown), {
                              modelValue: _unref(values).LastEducation,
                              "onUpdate:modelValue": [
                                _cache[13] || (_cache[13] = ($event: any) => ((_unref(values).LastEducation) = $event)),
                                _cache[14] || (_cache[14] = (val) => _unref(setFieldValue)('LastEducation', val))
                              ],
                              options: lastEducationOptions.value,
                              optionLabel: "label",
                              placeholder: "Pilih Pendidikan Terakhir",
                              class: "w-full md:w-14rem"
                            }, null, 8, ["modelValue", "options"])
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ]),
                      _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(errors).LastEducation), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", {
                    for: "email",
                    class: "label-text"
                  }, "Email", -1)),
                  _createVNode(_unref(Field), { name: "Email" }, {
                    default: _withCtx(({ handleChange, handleBlur, field }) => [
                      _createVNode(_unref(InputText), _mergeProps({ id: "email" }, field, {
                        "aria-describedby": "email-help",
                        class: `input-primary ${_unref(errors).Email ? 'input-invalid' : ''}`,
                        placeholder: "Masukkan Email",
                        onChange: handleChange,
                        onBlur: handleBlur
                      }), null, 16, ["class", "onChange", "onBlur"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(errors).Email), 1)
                ])
              ])
            ]),
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col-1" }, [
              _createElementVNode("p", { class: "font-bold text-xl mb-2" }, "Alamat Karyawan")
            ], -1)),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", {
                    for: "province",
                    class: "label-text required"
                  }, "Provinsi", -1)),
                  _createVNode(_unref(Field), {
                    id: "province",
                    name: "Province",
                    class: _normalizeClass(`input-primary ${_unref(errors).Province ? 'input-invalid' : ''}`),
                    validateOnInput: true
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(SelectAsync, _mergeProps(field, {
                        inputId: `province`,
                        endpoint: `${provinceEndpoint}`,
                        fieldLabel: (v) => `${v.name}`,
                        modelValue: _unref(values).Province,
                        clearable: true,
                        searchFields: ['name'],
                        placeholder: `Pilih Provinsi`,
                        classname: 'custom-select',
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = (val) => onProvinceChange(val, _unref(setFieldValue)))
                      }), null, 16, ["endpoint", "fieldLabel", "modelValue"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(errors).Province), 1)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", {
                    for: "postalCode",
                    class: "label-text required"
                  }, "Kode Pos", -1)),
                  _createVNode(_unref(Field), { name: "PostalCode" }, {
                    default: _withCtx(({ handleChange, handleBlur, field }) => [
                      _createVNode(_unref(InputText), _mergeProps({
                        class: `input-primary ${_unref(errors).PostalCode ? 'input-invalid' : ''}`,
                        id: "postalCode"
                      }, field, {
                        "aria-describedby": "postalcode-help",
                        placeholder: "61000",
                        type: "text",
                        onChange: handleChange,
                        onBlur: handleBlur,
                        minlength: 5,
                        maxlength: 5
                      }), null, 16, ["class", "onChange", "onBlur"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(errors).PostalCode), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", {
                    for: "city",
                    class: "label-text required"
                  }, "Kota", -1)),
                  _createVNode(_unref(Field), {
                    id: "city",
                    name: "City",
                    class: _normalizeClass(`input-primary ${_unref(errors).City ? 'input-invalid' : ''}`),
                    validateOnInput: true
                  }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(SelectAsync, _mergeProps(field, {
                        inputId: `city`,
                        endpoint: `${cityEndpoint}`,
                        fieldLabel: (v) => `${v.name}`,
                        modelValue: _unref(values).City,
                        clearable: true,
                        searchFields: ['name'],
                        placeholder: `Pilih Kota`,
                        classname: 'custom-select',
                        disabled: !_unref(values).Province,
                        "search-custom": [['provinceId', '=', _unref(values).Province?.id]]
                      }), null, 16, ["endpoint", "fieldLabel", "modelValue", "disabled", "search-custom"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(errors).City), 1)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", {
                    for: "address",
                    class: "label-text required"
                  }, "Alamat Domisili", -1)),
                  _createVNode(_unref(Field), {
                    id: "address",
                    name: "Address",
                    as: "textarea",
                    type: "text",
                    placeholder: "Ex. Jl. panjang blok Q",
                    class: _normalizeClass(`input-primary ${_unref(errors).Address ? 'input-invalid' : ''}`),
                    modelValue: _unref(values).Address,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(values).Address) = $event)),
                    validateOnInput: true,
                    rows: "5"
                  }, null, 8, ["class", "modelValue"]),
                  _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(errors).Address), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_unref(Button), {
                type: "submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => _cache[40] || (_cache[40] = [
                  _createTextVNode("Lanjut")
                ])),
                _: 1,
                __: [40]
              })
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true),
    _createVNode(HjpDefaultModal, {
      show: isShowCameraDialog.value,
      width: '50vw',
      onHideDialog: hideCameraDialog
    }, {
      content: _withCtx(() => [
        _createVNode(TakeCamera, {
          onUsePhoto: useCurrentPhoto,
          onHideDialog: hideCameraDialog
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(HjpCofirmModal, {
      show: isShowDataExistDialog.value,
      title: confirmDataExistDialog.value?.title,
      subTitle: confirmDataExistDialog.value?.subTitle,
      btnSubmitTitle: confirmDataExistDialog.value?.btnSubmitTitle,
      subTitleHtml: confirmDataExistDialog.value?.isHtml,
      onHideDialog: hideDataExistDialog,
      onOnSubmit: toExistingDataDetail
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle", "subTitleHtml"])
  ]))
}
}

})